var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
import { getPreviousDayDate } from 'src/shared/utils/dates';
export var useMemberMedications = function (memberUserId, disabled, endDate) {
    var params = {};
    // since DoseSpot's date range is inclusive, we need to subtract a day from the end date
    if (endDate) {
        var previousDay = getPreviousDayDate(new Date(endDate));
        params = { endDate: previousDay.toISOString().slice(0, 10) };
    }
    var axios = useAxios();
    return useQuery(['member-medications', memberUserId + endDate], function () {
        return axios.get("api/v1/users/".concat(memberUserId, "/medications"), { params: params });
    }, {
        enabled: !!memberUserId && !disabled,
        refetchOnMount: false,
        select: function (response) {
            var _a, _b;
            return (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.medications.map(function (med) {
                var _a, _b, _c;
                return (__assign(__assign({}, med), { appointmentId: med.appointmentId || '', dispense: parseInt((_a = med.dispense) === null || _a === void 0 ? void 0 : _a.toString()) || 0, refills: parseInt((_b = med.refills) === null || _b === void 0 ? void 0 : _b.toString()) || 0, effectiveDate: new Date(med.effectiveDate).toISOString(), inactiveDate: new Date(med.inactiveDate).toISOString(), unit: med.unit || '', daysSupply: parseInt((_c = med.daysSupply) === null || _c === void 0 ? void 0 : _c.toString()) || 0 }));
            });
        },
    });
};
